import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../common/Loading'

export default Loadable({
  loader: () => import('./Listing'),
  loading: Loading
})
